import { Injectable } from '@angular/core';
import { URLService } from './_url.service';
import { Observable } from 'rxjs';
import { HttpService } from './core/http.service';
import { ResponseData } from './model/response.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private httpService: HttpService,private URLService: URLService) { }

  // GetOrdersListWorkStation(searchText: string,implementationType: number): Observable<ResponseData> {
  //     return this.httpService.post(this.URLService.GetOrdersListWorkStation, {searchText:searchText,implementationType:implementationType});
  //   }

    GetOrdersListWorkStation(filterModel: any): Observable<ResponseData> {
      console.log("filterModel Work station ",filterModel.order);
      return this.httpService.post(this.URLService.GetOrdersListWorkStation, filterModel);
    }

    GetDelayOrdersList(filterModel: any): Observable<ResponseData> {
      return this.httpService.post(this.URLService.GetDelayOrdersList, filterModel);
    }

    GetWorkFlow(filterModel: any): Observable<ResponseData> {
      return this.httpService.post(this.URLService.GetWorkFlow, filterModel);
    }
}
